import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-scheduler',
    templateUrl: './scheduler.component.html',
    styleUrls: ['./scheduler.component.scss'],
    standalone: false
})
export class SchedulerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
